export enum EFormaPagamento {
  PIX = 'Pix',
  CARTAO_CREDITO = 'Cartão de Crédito',
  BOLETO = 'Boleto',
}

interface FormaPagamentoInfo {
  nome: string;
  indice: number;
  label: string;
}

export const FormaPagamentoDetalhe: { [key in EFormaPagamento]: FormaPagamentoInfo } = {
  [EFormaPagamento.PIX]: {
    nome: 'PIX',
    indice: 0,
    label: 'Pix',
  },
  [EFormaPagamento.CARTAO_CREDITO]: {
    nome: 'CARTAO_CREDITO',
    indice: 1,
    label: 'Cartão de Crédito',
  },
  [EFormaPagamento.BOLETO]: {
    nome: 'BOLETO',
    indice: 2,
    label: 'Boleto',
  },
};

export function getValueFromEFormaPagamentoByIndex(index: number) {
  const labels = Object.values(EFormaPagamento);
  return labels[index];
}
